const EMAILJS_URL = 'https://api.emailjs.com/api/v1.0/email/send'
const EMAILJS_SERVICE_ID = 'service_e5leat9'
const EMAILJS_TEMPLATE_ID = 'template_7kxwckd'
const EMAILJS_PUBLIC_KEY = 'jPcnxBxjvJjl5Qnb_'

interface FormPayload {
  subject: string
  [key: string]: string | number | boolean | undefined
}

export async function sendFormEmail(data: FormPayload): Promise<boolean> {
  try {
    // Extract FormSubmit-specific fields and map to EmailJS equivalents
    const { _replyto, _autoresponse, _cc, _captcha, _template, ...cleanData } =
      data as Record<string, any>

    const res = await fetch(EMAILJS_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        service_id: EMAILJS_SERVICE_ID,
        template_id: EMAILJS_TEMPLATE_ID,
        user_id: EMAILJS_PUBLIC_KEY,
        template_params: {
          ...cleanData,
          // EmailJS uses to_email for the main recipient
          to_email: 'viczerga@gmail.com',
          // EmailJS uses reply_to for the auto-reply recipient
          reply_to: _replyto || cleanData.email || '',
          // Pass auto-response text so the template can use it
          auto_response: _autoresponse || '',
        },
      }),
    })
    return res.ok
  } catch (err) {
    console.error('Form submission error:', err)
    return false
  }
}
